module.exports = __webpack_public_path__ + "static/media/class_job_030.ab970453.svg";